import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrain = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 18V5" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.997 5.125a4 4 0 0 1 2.526 5.77" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 18a4 4 0 0 0 2-7.464" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 18a4 4 0 0 1-2-7.464" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.003 5.125a4 4 0 0 0-2.526 5.77" })
	]
});
const ForwardRef = forwardRef(SvgBrain);
export default ForwardRef;
